import { render, staticRenderFns } from "./PhysiciansList.vue?vue&type=template&id=53554d1a&"
import script from "./PhysiciansList.vue?vue&type=script&lang=js&"
export * from "./PhysiciansList.vue?vue&type=script&lang=js&"
import style0 from "./PhysiciansList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VDivider,VIcon,VSimpleCheckbox})
